import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {NewSearchWidgetEntitiesSectionTitle} from "./new-search-widget.entities.section.title";
import {NewSearchWidgetEntitiesList} from "./new-search-widget.entities.list";
import {NewSearchWidgetEntitiesSeeAll} from "./new-search-widget.entities.see-all";

export const NewSearchWidgetEntitiesSection = observer(({
                                                          controller,
                                                          listModel,
                                                          hasRecentSearchesItems,
                                                          highlightedItemIndex,
                                                          isRecentSearchesList,
                                                          onMouseEnter
                                                        }) => {
  const {state, device} = controller;
  const {hasResults, isListSingleView, selectedListId} = state;
  const {isSmallView} = device;

  if(isListSingleView && selectedListId !== listModel.id) {
    return null
  }

  const shouldRenderListEmptyState: Boolean = isRecentSearchesList ? !listModel?.hasEntities : !listModel?.hasEntities && hasResults
  const shouldRenderSection: Boolean = !isSmallView || !shouldRenderListEmptyState

  const baseProps = {
    controller,
    listModel,
  }

  const titleProps = {
    hasRecentSearchesItems,
    ...baseProps
  }

  const listProps = {
    isRecentSearchesList,
    shouldRenderListEmptyState,
    highlightedItemIndex,
    onMouseEnter,
    ...baseProps
  }

  const seeAllProps = {
    isRecentSearchesList,
    ...baseProps
  }

  return (
    shouldRenderSection ? <div className={classNames(styles.entities_section)}>
      <NewSearchWidgetEntitiesSectionTitle {...titleProps}/>
      <NewSearchWidgetEntitiesList {...listProps}/>
      <NewSearchWidgetEntitiesSeeAll {...seeAllProps}/>
    </div> : null
  )
});
